import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Account extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getAccountGroupAgent(params) {
    return this.httpService.get("Accounts/group-agent", {
      headers,
      params,
    });
  }

  getAccountGroupInfo(params) {
    return this.httpService.get("Accounting/info", {
      headers,
      params,
    });
  }

  getAccountGroupHistory(params) {
    return this.httpService.get("/Accounting/History", {
      headers,
      params,
    });
  }

  getAccountGroupHistoryDetails(params) {
    return this.httpService.get("/Accounting/History/detail", {
      headers,
      params,
    });
  }

  getAccountGroupUsers(params) {
    return this.httpService.get("/Accounts/group-users", {
      headers,
      params,
    });
  }

  getAllUserGroup(params) {
    return this.httpService.get("/Accounts/all-user-group", {
      headers,
      params,
    });
  }

  getAccountGroupHistoryFactor(params) {
    return this.httpService.get("/Accounting/History/factor", {
      headers,
      params,
    });
  }

  getAccountGroupLimits(params) {
    return this.httpService.get("/Accounting/History/limit", {
      headers,
      params,
    });
  }

  getActivePeriods(params) {
    return this.httpService.get("/Accounting/period/active", {
      headers,
      params,
    });
  }

  getServiceCombo(params) {
    return this.httpService.get("/Accounting/service-combo", {
      headers,
      params,
    });
  }

  getProductCombo(params) {
    return this.httpService.get("/Accounting/product-combo", {
      headers,
      params,
    });
  }

  getFactorCombo(params) {
    return this.httpService.get("/Accounting/factor-combo", {
      headers,
      params,
    });
  }

  getAccountsAllGroup(params) {
    return this.httpService.get("/Accounts/all-group", {
      headers,
      params,
    });
  }

  getAccountingFinancial(params) {
    return this.httpService.get("/Accounting/Financial", {
      headers,
      params,
    });
  }

  getAccountingFinancialExport(params) {
    return this.httpService.get("/Accounting/Financial/export", {
      headers,
      params,
    });
  }

  postUpgradeCalculate(data) {
    return this.httpService.post("/Accounting/upgrade/calculate", data, {
      headers,
    });
  }

  postUpgradeFinal(data) {
    return this.httpService.post("/Accounting/upgrade/final", data, {
      headers,
    });
  }

  putDisableUserBySuperAdmin(data) {
    return this.httpService.put("/Accounts/disable", data, { headers });
  }

  getAccountingPriceSupervisor(params) {
    return this.httpService.get("/Accounting/Price/Supervisor", {
      headers,
      params,
    });
  }
  postAccountingPriceSupervisor(data) {
    return this.httpService.post("/Accounting/Price/Supervisor", data, {
      headers,
    });
  }
  putAccountingPriceSupervisor(data) {
    return this.httpService.put("/Accounting/Price/Supervisor", data, {
      headers,
    });
  }
  deleteAccountingPriceSupervisor(data) {
    return this.httpService.delete("/Accounting/Price/Supervisor", {
      headers,
      data,
    });
  }

  getAccountingPriceService(params) {
    return this.httpService.get("/Accounting/PriceService", {
      headers,
      params,
    });
  }
  postAccountingPriceService(data) {
    return this.httpService.post("/Accounting/PriceService", data, { headers });
  }
  putAccountingPriceService(data) {
    return this.httpService.put("/Accounting/PriceService", data, { headers });
  }
  deleteAccountingPriceService(data) {
    return this.httpService.delete("/Accounting/PriceService", {
      headers,
      data,
    });
  }
  getAccountingPriceProduct(params) {
    return this.httpService.get("/Accounting/Price/product", {
      headers,
      params,
    });
  }
  postAccountingPriceProduct(data) {
    return this.httpService.post("/Accounting/Price/product", data, {
      headers,
    });
  }
  putAccountingPriceProduct(data) {
    return this.httpService.put("/Accounting/Price/product", data, { headers });
  }
  deleteAccountingPriceProduct(data) {
    return this.httpService.delete("/Accounting/Price/product", {
      headers,
      data,
    });
  }
  getAccountingPriceFactor(params) {
    return this.httpService.get("/Accounting/Price/factor", {
      headers,
      params,
    });
  }
  postAccountingPriceFactor(data) {
    return this.httpService.post("/Accounting/Price/factor", data, { headers });
  }
  putAccountingPriceFactor(data) {
    return this.httpService.put("/Accounting/Price/factor", data, { headers });
  }
  deleteAccountingPriceFactor(data) {
    return this.httpService.delete("/Accounting/Price/factor", {
      headers,
      data,
    });
  }
  getAccountingPricePeriod(params) {
    return this.httpService.get("/Accounting/period", { headers, params });
  }
  postAccountingPricePeriod(data) {
    return this.httpService.post("/Accounting/period", data, { headers });
  }
  putAccountingPricePeriod(data) {
    return this.httpService.put("/Accounting/period", data, { headers });
  }
  deleteAccountingPricePeriod(data) {
    return this.httpService.delete("/Accounting/period", { headers, data });
  }
  getAccountingHistoryIncTime(params) {
    return this.httpService.get("/Accounting/History/inc-time", {
      headers,
      params,
    });
  }
  getAccountingHistoryActive(params) {
    return this.httpService.get("/Accounting/History/active", {
      headers,
      params,
    });
  }
  postAccountingHistoryIncTime(data) {
    return this.httpService.post("/Accounting/History/inc-time", data, {
      headers,
    });
  }
  getAccountingDefaultPanel(params) {
    return this.httpService.get("/Accounting/DefaultPanel", {
      headers,
      params,
    });
  }
  postAccountingDefaultPanel(data) {
    return this.httpService.post("/Accounting/DefaultPanel", data, { headers });
  }
  putAccountingDefaultPanel(data) {
    return this.httpService.put("/Accounting/DefaultPanel", data, { headers });
  }
  deleteAccountingDefaultPanel(data) {
    return this.httpService.delete("/Accounting/DefaultPanel", {
      headers,
      data,
    });
  }
  getAccountingDefaultCharge(params) {
    return this.httpService.get("/Accounting/DefaultCharge", {
      headers,
      params,
    });
  }
  postAccountingDefaultCharge(data) {
    return this.httpService.post("/Accounting/DefaultCharge", data, {
      headers,
    });
  }
  putAccountingDefaultCharge(data) {
    return this.httpService.put("/Accounting/DefaultCharge", data, { headers });
  }
  deleteAccountingDefaultCharge(data) {
    return this.httpService.delete("/Accounting/DefaultCharge", {
      headers,
      data,
    });
  }
  getAccountingManualCredit(params) {
    return this.httpService.get("/Accounting/ManualCredit", {
      headers,
      params,
    });
  }
  postAccountingManualCredit(data) {
    return this.httpService.post("/Accounting/ManualCredit", data, { headers });
  }
  getAccountingDManualCreditMethod(params) {
    return this.httpService.get("/Accounting/ManualCredit/method", {
      headers,
      params,
    });
  }
  getAccountingDManualCreditType(params) {
    return this.httpService.get("/Accounting/ManualCredit/type", {
      headers,
      params,
    });
  }
  getAccountingDiscountCard(params) {
    return this.httpService.get("/Accounting/DiscountCard", {
      headers,
      params,
    });
  }
  postAccountingDiscountCard(data) {
    return this.httpService.post("/Accounting/DiscountCard", data, { headers });
  }
  putAccountingDiscountCard(data) {
    return this.httpService.put("/Accounting/DiscountCard", data, { headers });
  }
  deleteAccountingDiscountCard(data) {
    return this.httpService.delete("/Accounting/DiscountCard", {
      headers,
      data,
    });
  }
  getAccountingDiscountCardUsed(params) {
    return this.httpService.get("/Accounting/DiscountCard/used", {
      headers,
      params,
    });
  }
  getAccountingDiscountCardStype(params) {
    return this.httpService.get("/Accounting/DiscountCard/stype", {
      headers,
      params,
    });
  }
  getAccountingDiscountCardRefrence(params) {
    return this.httpService.get("/Accounting/DiscountCard/refrence", {
      headers,
      params,
    });
  }
}
const AccountService = new Account();
export default AccountService;
